export const FileUploaderConstants = {
  DROP_AREA: {
    TITLE: 'Simply drop your files here or ',
    SUBTITLE: (_fileTypes: string[]) => `Files supported: ${_fileTypes}`,
    SUBTITLE2: 'Browse Files',
    AFTER_FILE_SELECTED: "Great! You've selected your files. Ready to upload!",
  },
  LINK_INPUT_TITLE: 'Add Link to your file',
  LINK_INPUT_PLACEHOLDER: 'Paste your Link Here',
  UPLOAD: 'Upload',
  CANCEL: 'Cancel',
  REVIEW_CONTRACT: 'Review Contracts',
  FILE: 'FILE',
  LINK: 'LINK',

  UPLOAD_SUCCESS: (_fileName: string) =>
    `${_fileName} file uploaded sucessfully`,
  UPLOAD_ERROR: (_fileName: string) => `${_fileName} file not uploaded`,
};
